module.exports = __webpack_public_path__ + "img/onlineErp-2.6b640692.png";